import React from 'react';
import './index.css';
import App from './App';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter} from 'react-router-dom'
import Layout from './pages/Layout';
import Landing from './pages/Landing';
import ApproachMain from './pages/ApproachMain'
import OurApproach from './pages/OurApproach'
import Company from './pages/Company'
import Projects from './pages/Projects'
import Project from './pages/Project'
import CaseStudy from './pages/CaseStudy'
import AboutUs from './pages/AboutUs'
import ProjectVideos from './pages/ProjectVideos';
import './firebase'

import thumbnail1 from './assets/projects/AVEVA CEC Launch/DSC03837.jpg'
import thumbnail2 from './assets/projects/CHUBB Hyderbad Inauguration/NAR06953.jpg'
import thumbnail3 from './assets/projects/CHUBB Kids Carnival/NAR00459.jpg'
import thumbnail4 from './assets/projects/EVERNORTH Launch/DSC09284.jpg'
import thumbnail5 from './assets/projects/EVERNORTH Celebrations/DSC00004.jpg'
import thumbnail6 from './assets/projects/Facset AARAMBH 2023/DSC09201.jpg'
import thumbnail7 from './assets/projects/Facset Blockbuster 2019/239A8763.jpg'
import thumbnail8 from './assets/projects/Facset Blockbuster 2024/DSC05019.jpg'
import thumbnail9 from './assets/projects/Hyderabad City Police/CNU_8371.jpg'
import thumbnail10 from './assets/projects/Invesco Family Day/_R5A3543.jpg'
import thumbnail11 from './assets/projects/MassMutual kids Carnival/A09A6408.jpg'
import thumbnail12 from './assets/projects/MassMutual Pulse 2023/DSC00012.jpg'
import thumbnail13 from './assets/projects/MassMutual Sangam/DSC06746.jpg'
import thumbnail14 from './assets/projects/MassMutual_Beyond Horizon/A09A2996.jpg'
import thumbnail15 from './assets/projects/MassMutual_LeadershipMeet/JG_01867.jpg'
import thumbnail16 from './assets/projects/Rimini Street 10 Years Celebrations/DJI_0082.jpg'
import thumbnail17 from './assets/projects/S&P Global/528A6816.jpg'
import thumbnail18 from './assets/projects/S&P Global gala celebrations/7K7A0051.jpg'
import thumbnail19 from './assets/projects/She Team_Hyderabad City Police/CNU_8562.jpg'
import thumbnail20 from './assets/projects/Value Labs Annual Event/IMG_0182.jpg'



import img1_1 from './assets/projects/AVEVA CEC Launch/DSC03776.jpg'
import img1_2 from './assets/projects/AVEVA CEC Launch/DSC03810.jpg'
import img1_3 from './assets/projects/AVEVA CEC Launch/DSC03823.jpg'
import img1_4 from './assets/projects/AVEVA CEC Launch/DSC03837.jpg'
import img1_5 from './assets/projects/AVEVA CEC Launch/DSC03842.jpg'
import img1_6 from './assets/projects/AVEVA CEC Launch/DSC03886.jpg'
import img1_7 from './assets/projects/AVEVA CEC Launch/DSC03888.jpg'
import img1_8 from './assets/projects/AVEVA CEC Launch/DSC03893.jpg'
import img1_9 from './assets/projects/AVEVA CEC Launch/DSC03941.jpg'
import img1_10 from './assets/projects/AVEVA CEC Launch/DSC03947.jpg'
import img1_11 from './assets/projects/AVEVA CEC Launch/DSC03953.jpg'
import img1_12 from './assets/projects/AVEVA CEC Launch/DSC03987.jpg'
import img1_13 from './assets/projects/AVEVA CEC Launch/DSC04077.jpg'
import img1_14 from './assets/projects/AVEVA CEC Launch/DSC04216.jpg'
import img1_15 from './assets/projects/AVEVA CEC Launch/DSC04374.jpg'
import img1_16 from './assets/projects/AVEVA CEC Launch/NAR08959.jpg'
import img1_17 from './assets/projects/AVEVA CEC Launch/NAR08965.jpg'
import img1_18 from './assets/projects/AVEVA CEC Launch/NAR08968.jpg'
import img1_19 from './assets/projects/AVEVA CEC Launch/NAR08980.jpg'
import img1_20 from './assets/projects/AVEVA CEC Launch/NAR08998.jpg'
import img1_21 from './assets/projects/AVEVA CEC Launch/NAR09010.jpg'
import img1_22 from './assets/projects/AVEVA CEC Launch/NAR09028.jpg'
import img1_23 from './assets/projects/AVEVA CEC Launch/NAR09042.jpg'
import img1_24 from './assets/projects/AVEVA CEC Launch/NAR09058.jpg'
import img1_25 from './assets/projects/AVEVA CEC Launch/NAR09083.jpg'
import img1_26 from './assets/projects/AVEVA CEC Launch/NAR09176.jpg'
import img1_27 from './assets/projects/AVEVA CEC Launch/NAR09222.jpg'
import img1_28 from './assets/projects/AVEVA CEC Launch/NAR09243.jpg'
import img1_29 from './assets/projects/AVEVA CEC Launch/NAR09258.jpg'
import img1_30 from './assets/projects/AVEVA CEC Launch/NAR09276.jpg'
import img1_31 from './assets/projects/AVEVA CEC Launch/NAR09300.jpg'
import img1_32 from './assets/projects/AVEVA CEC Launch/NAR09340.jpg'
import img1_33 from './assets/projects/AVEVA CEC Launch/NAR09380.jpg'
import img1_34 from './assets/projects/AVEVA CEC Launch/NAR09391.jpg'
import img1_35 from './assets/projects/AVEVA CEC Launch/NAR09442.jpg'
import img1_36 from './assets/projects/AVEVA CEC Launch/NAR09465.jpg'
import img1_37 from './assets/projects/AVEVA CEC Launch/NAR09485.jpg'
import img1_38 from './assets/projects/AVEVA CEC Launch/NAR09469.jpg'
import img1_39 from './assets/projects/AVEVA CEC Launch/NAR09488.jpg'
import img1_40 from './assets/projects/AVEVA CEC Launch/NAR09506.jpg'
import img1_41 from './assets/projects/AVEVA CEC Launch/NAR09547.jpg'
import img1_42 from './assets/projects/AVEVA CEC Launch/NAR09579.jpg'
import img1_43 from './assets/projects/AVEVA CEC Launch/NAR09583.jpg'
import img1_44 from './assets/projects/AVEVA CEC Launch/NAR09598.jpg'
import img1_45 from './assets/projects/AVEVA CEC Launch/NAR09622.jpg'
import img1_46 from './assets/projects/AVEVA CEC Launch/NAR09659.jpg'
import img1_47 from './assets/projects/AVEVA CEC Launch/NAR09804.jpg'
import img1_48 from './assets/projects/AVEVA CEC Launch/NAR09813.jpg'
import img1_49 from './assets/projects/AVEVA CEC Launch/NAR09816.jpg'


import img2_1 from './assets/projects/CHUBB Hyderbad Inauguration/NAR06948.jpg'
import img2_2 from './assets/projects/CHUBB Hyderbad Inauguration/NAR06953.jpg'
import img2_3 from './assets/projects/CHUBB Hyderbad Inauguration/NAR06962.jpg'
import img2_4 from './assets/projects/CHUBB Hyderbad Inauguration/NAR06979.jpg'
import img2_5 from './assets/projects/CHUBB Hyderbad Inauguration/NAR06984.jpg'
import img2_6 from './assets/projects/CHUBB Hyderbad Inauguration/NAR06989.jpg'
import img2_7 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07025.jpg'
import img2_8 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07058.jpg'
import img2_9 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07059.jpg'
import img2_10 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07068.jpg'
import img2_11 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07071.jpg'
import img2_12 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07079.jpg'
import img2_13 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07095.jpg'
import img2_14 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07101.jpg'
import img2_15 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07105.jpg'
import img2_16 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07129.jpg'
import img2_17 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07142.jpg'
import img2_18 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07171.jpg'
import img2_19 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07173.jpg'
import img2_20 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07179.jpg'
import img2_21 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07210.jpg'
import img2_22 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07230.jpg'
import img2_23 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07233.jpg'
import img2_24 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07266.jpg'
import img2_25 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07285.jpg'
import img2_26 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07631.jpg'
import img2_27 from './assets/projects/CHUBB Hyderbad Inauguration/NAR07664.jpg'

import img3_1 from './assets/projects/CHUBB Kids Carnival/250-2.jpg'
import img3_2 from './assets/projects/CHUBB Kids Carnival/250.jpg'
import img3_3 from './assets/projects/CHUBB Kids Carnival/390-2.jpg.jpg'
import img3_4 from './assets/projects/CHUBB Kids Carnival/390.jpg.jpg'
import img3_5 from './assets/projects/CHUBB Kids Carnival/400.jpg.jpg'
import img3_6 from './assets/projects/CHUBB Kids Carnival/420jpg.jpg'
import img3_7 from './assets/projects/CHUBB Kids Carnival/NAR00168.jpg'
import img3_8 from './assets/projects/CHUBB Kids Carnival/NAR00416.jpg'
import img3_9 from './assets/projects/CHUBB Kids Carnival/NAR00459.jpg'
import img3_10 from './assets/projects/CHUBB Kids Carnival/NAR09812-2.jpg'
import img3_11 from './assets/projects/CHUBB Kids Carnival/NAR09818.jpg'
import img3_12 from './assets/projects/CHUBB Kids Carnival/NAR09826.jpg'
import img3_13 from './assets/projects/CHUBB Kids Carnival/NAR09833.jpg'
import img3_14 from './assets/projects/CHUBB Kids Carnival/NAR09850.jpg'
import img3_15 from './assets/projects/CHUBB Kids Carnival/NAR09867-2.jpg'
import img3_16 from './assets/projects/CHUBB Kids Carnival/NAR09872.jpg'
import img3_17 from './assets/projects/CHUBB Kids Carnival/NAR09904.jpg'
import img3_18 from './assets/projects/CHUBB Kids Carnival/NAR09908.jpg'
import img3_19 from './assets/projects/CHUBB Kids Carnival/NAR09916.jpg'
import img3_20 from './assets/projects/CHUBB Kids Carnival/NAR09983.jpg'


import img4_1 from './assets/projects/EVERNORTH Launch/DSC00002.jpg'
import img4_2 from './assets/projects/EVERNORTH Launch/DSC00007.jpg'
import img4_3 from './assets/projects/EVERNORTH Launch/DSC00009.jpg'
import img4_4 from './assets/projects/EVERNORTH Launch/DSC00020.jpg'
import img4_5 from './assets/projects/EVERNORTH Launch/DSC00049.jpg'
import img4_6 from './assets/projects/EVERNORTH Launch/DSC00074.jpg'
import img4_7 from './assets/projects/EVERNORTH Launch/DSC00014.jpg'
import img4_8 from './assets/projects/EVERNORTH Launch/DSC09245.jpg'
import img4_9 from './assets/projects/EVERNORTH Launch/DSC09246.jpg'
import img4_10 from './assets/projects/EVERNORTH Launch/DSC09248.jpg'
import img4_11 from './assets/projects/EVERNORTH Launch/DSC09250.jpg'
import img4_12 from './assets/projects/EVERNORTH Launch/DSC09252.jpg'
import img4_13 from './assets/projects/EVERNORTH Launch/DSC09255.jpg'
import img4_14 from './assets/projects/EVERNORTH Launch/DSC09266.jpg'
import img4_15 from './assets/projects/EVERNORTH Launch/DSC09273.jpg'
import img4_16 from './assets/projects/EVERNORTH Launch/DSC09276.jpg'
import img4_17 from './assets/projects/EVERNORTH Launch/DSC09277.jpg'
import img4_18 from './assets/projects/EVERNORTH Launch/DSC09284.jpg'
import img4_19 from './assets/projects/EVERNORTH Launch/DSC09289.jpg'
import img4_20 from './assets/projects/EVERNORTH Launch/DSC09301.jpg'
import img4_21 from './assets/projects/EVERNORTH Launch/DSC09316.jpg'
import img4_22 from './assets/projects/EVERNORTH Launch/DSC09325.jpg'
import img4_23 from './assets/projects/EVERNORTH Launch/DSC09397.jpg'
import img4_24 from './assets/projects/EVERNORTH Launch/DSC09399.jpg'
import img4_25 from './assets/projects/EVERNORTH Launch/DSC09401.jpg'
import img4_26 from './assets/projects/EVERNORTH Launch/DSC09406.jpg'
import img4_27 from './assets/projects/EVERNORTH Launch/DSC09407.jpg'
import img4_28 from './assets/projects/EVERNORTH Launch/DSC09408.jpg'
import img4_29 from './assets/projects/EVERNORTH Launch/DSC09411.jpg'
import img4_30 from './assets/projects/EVERNORTH Launch/DSC09431.jpg'
import img4_31 from './assets/projects/EVERNORTH Launch/DSC09433.jpg'
import img4_32 from './assets/projects/EVERNORTH Launch/DSC09437.jpg'
import img4_33 from './assets/projects/EVERNORTH Launch/DSC09463.jpg'
import img4_34 from './assets/projects/EVERNORTH Launch/DSC09481.jpg'
import img4_35 from './assets/projects/EVERNORTH Launch/DSC09482.jpg'
import img4_36 from './assets/projects/EVERNORTH Launch/DSC09483.jpg'
import img4_37 from './assets/projects/EVERNORTH Launch/DSC09502.jpg'
import img4_38 from './assets/projects/EVERNORTH Launch/DSC09524.jpg'
import img4_39 from './assets/projects/EVERNORTH Launch/DSC09862.jpg'
import img4_40 from './assets/projects/EVERNORTH Launch/DSC09863.jpg'
import img4_41 from './assets/projects/EVERNORTH Launch/DSC09984.jpg'
import img4_42 from './assets/projects/EVERNORTH Launch/DSC09987.jpg'
import img4_43 from './assets/projects/EVERNORTH Launch/DSC09992.jpg'
import img4_44 from './assets/projects/EVERNORTH Launch/DSC09993.jpg'
import img4_45 from './assets/projects/EVERNORTH Launch/NAR05092.jpg'
import img4_46 from './assets/projects/EVERNORTH Launch/NAR06106.jpg'




import img5_1 from './assets/projects/EVERNORTH Celebrations/DSC00004.jpg'
import img5_2 from './assets/projects/EVERNORTH Celebrations/DSC00658.jpg'
import img5_3 from './assets/projects/EVERNORTH Celebrations/DSC00973.jpg'
import img5_4 from './assets/projects/EVERNORTH Celebrations/DSC01018.jpg'
import img5_5 from './assets/projects/EVERNORTH Celebrations/DSC01026.jpg'
import img5_6 from './assets/projects/EVERNORTH Celebrations/DSC01032.jpg'
import img5_7 from './assets/projects/EVERNORTH Celebrations/DSC01041.jpg'
import img5_8 from './assets/projects/EVERNORTH Celebrations/DSC01097.jpg'
import img5_9 from './assets/projects/EVERNORTH Celebrations/DSC01111.jpg'
import img5_10 from './assets/projects/EVERNORTH Celebrations/DSC01145.jpg'
import img5_12 from './assets/projects/EVERNORTH Celebrations/DSC01153.jpg'
import img5_11 from './assets/projects/EVERNORTH Celebrations/DSC01166.jpg'
import img5_13 from './assets/projects/EVERNORTH Celebrations/DSC01224.jpg'
import img5_14 from './assets/projects/EVERNORTH Celebrations/DSC01323.jpg'
import img5_15 from './assets/projects/EVERNORTH Celebrations/DSC01357.jpg'
import img5_16 from './assets/projects/EVERNORTH Celebrations/DSC01454.jpg'
import img5_17 from './assets/projects/EVERNORTH Celebrations/DSC01466.jpg'
import img5_18 from './assets/projects/EVERNORTH Celebrations/DSC01530.jpg'
import img5_19 from './assets/projects/EVERNORTH Celebrations/DSC01538.jpg'
import img5_20 from './assets/projects/EVERNORTH Celebrations/DSC01556.jpg'
import img5_21 from './assets/projects/EVERNORTH Celebrations/DSC01568.jpg'
import img5_22 from './assets/projects/EVERNORTH Celebrations/DSC01621.jpg'
import img5_23 from './assets/projects/EVERNORTH Celebrations/DSC01625.jpg'
import img5_24 from './assets/projects/EVERNORTH Celebrations/DSC01636.jpg'
import img5_25 from './assets/projects/EVERNORTH Celebrations/DSC01682.jpg'
import img5_26 from './assets/projects/EVERNORTH Celebrations/DSC01926.jpg'
import img5_27 from './assets/projects/EVERNORTH Celebrations/DSC02270.jpg'
import img5_28 from './assets/projects/EVERNORTH Celebrations/DSC02373.jpg'
import img5_29 from './assets/projects/EVERNORTH Celebrations/DSC02384.jpg'
import img5_30 from './assets/projects/EVERNORTH Celebrations/DSC02458.jpg'
import img5_31 from './assets/projects/EVERNORTH Celebrations/DSC02500.jpg'
import img5_32 from './assets/projects/EVERNORTH Celebrations/DSC09514.jpg'
import img5_33 from './assets/projects/EVERNORTH Celebrations/DSC09628.jpg'
import img5_34 from './assets/projects/EVERNORTH Celebrations/DSC09631.jpg'
import img5_35 from './assets/projects/EVERNORTH Celebrations/DSC09674.jpg'
import img5_36 from './assets/projects/EVERNORTH Celebrations/DSC09677.jpg'
import img5_37 from './assets/projects/EVERNORTH Celebrations/DSC09708.jpg'
import img5_38 from './assets/projects/EVERNORTH Celebrations/DSC09729.jpg'
import img5_39 from './assets/projects/EVERNORTH Celebrations/DSC09740.jpg'
import img5_41 from './assets/projects/EVERNORTH Celebrations/DSC09756.jpg'
import img5_42 from './assets/projects/EVERNORTH Celebrations/DSC09862.jpg'
import img5_43 from './assets/projects/EVERNORTH Celebrations/DSC09863.jpg'
import img5_44 from './assets/projects/EVERNORTH Celebrations/DSC09905.jpg'
import img5_45 from './assets/projects/EVERNORTH Celebrations/DSC09948.jpg'
import img5_46 from './assets/projects/EVERNORTH Celebrations/DSC09963.jpg'
import img5_47 from './assets/projects/EVERNORTH Celebrations/DSC09983.jpg'
import img5_48 from './assets/projects/EVERNORTH Celebrations/DSC09992.jpg'
import img5_49 from './assets/projects/EVERNORTH Celebrations/DSC099922.jpg'
import img5_50 from './assets/projects/EVERNORTH Celebrations/DSC09995.jpg'
import img5_51 from './assets/projects/EVERNORTH Celebrations/DSC09998.jpg'
import img5_52 from './assets/projects/EVERNORTH Celebrations/IMGL0013.jpg'
import img5_53 from './assets/projects/EVERNORTH Celebrations/IMGL0017.jpg'
import img5_54 from './assets/projects/EVERNORTH Celebrations/IMGL0020.jpg'
import img5_55 from './assets/projects/EVERNORTH Celebrations/IMGL0025.jpg'
import img5_56 from './assets/projects/EVERNORTH Celebrations/IMGL0080.jpg'
import img5_57 from './assets/projects/EVERNORTH Celebrations/IMGL0091.jpg'


import img6_1 from './assets/projects/Facset AARAMBH 2023/DSC00008.jpg'
import img6_2 from './assets/projects/Facset AARAMBH 2023/DSC00052.jpg'
import img6_3 from './assets/projects/Facset AARAMBH 2023/DSC00072.jpg'
import img6_4 from './assets/projects/Facset AARAMBH 2023/DSC00116.jpg'
import img6_5 from './assets/projects/Facset AARAMBH 2023/DSC00224.jpg'
import img6_6 from './assets/projects/Facset AARAMBH 2023/DSC00244.jpg'
import img6_7 from './assets/projects/Facset AARAMBH 2023/DSC00819.jpg'
import img6_8 from './assets/projects/Facset AARAMBH 2023/DSC00951.jpg'
import img6_9 from './assets/projects/Facset AARAMBH 2023/DSC00952.jpg'
import img6_10 from './assets/projects/Facset AARAMBH 2023/DSC00975.jpg'
import img6_11 from './assets/projects/Facset AARAMBH 2023/DSC01008.jpg'
import img6_12 from './assets/projects/Facset AARAMBH 2023/DSC01041.jpg'
import img6_13 from './assets/projects/Facset AARAMBH 2023/DSC01052.jpg'
import img6_14 from './assets/projects/Facset AARAMBH 2023/DSC01057.jpg'
import img6_15 from './assets/projects/Facset AARAMBH 2023/DSC01079.jpg'
import img6_16 from './assets/projects/Facset AARAMBH 2023/DSC01163.jpg'
import img6_17 from './assets/projects/Facset AARAMBH 2023/DSC01190.jpg'
import img6_18 from './assets/projects/Facset AARAMBH 2023/DSC01264.jpg'
import img6_19 from './assets/projects/Facset AARAMBH 2023/DSC01372.jpg'
import img6_20 from './assets/projects/Facset AARAMBH 2023/DSC01378.jpg'
import img6_21 from './assets/projects/Facset AARAMBH 2023/DSC01462.jpg'
import img6_22 from './assets/projects/Facset AARAMBH 2023/DSC09177.jpg'
import img6_23 from './assets/projects/Facset AARAMBH 2023/DSC09185.jpg'
import img6_24 from './assets/projects/Facset AARAMBH 2023/DSC09198.jpg'
import img6_25 from './assets/projects/Facset AARAMBH 2023/DSC09201.jpg';
import img6_26 from './assets/projects/Facset AARAMBH 2023/DSC09232.jpg';
import img6_27 from './assets/projects/Facset AARAMBH 2023/DSC09269.jpg';
import img6_28 from './assets/projects/Facset AARAMBH 2023/DSC09293.jpg';
import img6_29 from './assets/projects/Facset AARAMBH 2023/DSC09317.jpg';
import img6_30 from './assets/projects/Facset AARAMBH 2023/DSC09479.jpg';
import img6_31 from './assets/projects/Facset AARAMBH 2023/DSC09544.jpg';
import img6_32 from './assets/projects/Facset AARAMBH 2023/DSC09580.jpg';
import img6_33 from './assets/projects/Facset AARAMBH 2023/DSC09605.jpg';
import img6_34 from './assets/projects/Facset AARAMBH 2023/DSC09633.jpg';
import img6_35 from './assets/projects/Facset AARAMBH 2023/DSC09649.jpg';
import img6_36 from './assets/projects/Facset AARAMBH 2023/DSC09749.jpg';
import img6_37 from './assets/projects/Facset AARAMBH 2023/DSC09661.jpg';
import img6_38 from './assets/projects/Facset AARAMBH 2023/DSC09781.jpg';
import img6_39 from './assets/projects/Facset AARAMBH 2023/DSC09813.jpg';
import img6_40 from './assets/projects/Facset AARAMBH 2023/DSC09881.jpg';
import img6_41 from './assets/projects/Facset AARAMBH 2023/DSC09937.jpg';
import img6_42 from './assets/projects/Facset AARAMBH 2023/NAR06361.jpg';
import img6_43 from './assets/projects/Facset AARAMBH 2023/NAR06390.jpg';
import img6_44 from './assets/projects/Facset AARAMBH 2023/NAR06398.jpg';
import img6_45 from './assets/projects/Facset AARAMBH 2023/NAR06413.jpg';
import img6_46 from './assets/projects/Facset AARAMBH 2023/NAR06498.jpg';
import img6_47 from './assets/projects/Facset AARAMBH 2023/NAR06566.jpg';
import img6_48 from './assets/projects/Facset AARAMBH 2023/NAR06575.jpg';
import img6_49 from './assets/projects/Facset AARAMBH 2023/NAR06602.jpg';
import img6_50 from './assets/projects/Facset AARAMBH 2023/NAR06635.jpg';
import img6_51 from './assets/projects/Facset AARAMBH 2023/NAR06662.jpg';
import img6_52 from './assets/projects/Facset AARAMBH 2023/NAR06692.jpg';
import img6_53 from './assets/projects/Facset AARAMBH 2023/NAR06749.jpg';
import img6_54 from './assets/projects/Facset AARAMBH 2023/NAR06773.jpg';
import img6_55 from './assets/projects/Facset AARAMBH 2023/NAR06815.jpg';
import img6_56 from './assets/projects/Facset AARAMBH 2023/NAR06845.jpg';
import img6_57 from './assets/projects/Facset AARAMBH 2023/NAR06947.jpg';
import img6_58 from './assets/projects/Facset AARAMBH 2023/NAR07010.jpg';
import img6_59 from './assets/projects/Facset AARAMBH 2023/NAR07450.jpg';
import img6_60 from './assets/projects/Facset AARAMBH 2023/NAR07472.jpg';
import img6_61 from './assets/projects/Facset AARAMBH 2023/NAR07550.jpg';
import img6_62 from './assets/projects/Facset AARAMBH 2023/NAR07613.jpg';
import img6_63 from './assets/projects/Facset AARAMBH 2023/NAR07667.jpg';
import img6_64 from './assets/projects/Facset AARAMBH 2023/NAR07715.jpg';
import img6_65 from './assets/projects/Facset AARAMBH 2023/NAR07754.jpg';
import img6_66 from './assets/projects/Facset AARAMBH 2023/NAR07838.jpg';
import img6_67 from './assets/projects/Facset AARAMBH 2023/NAR07862.jpg';
import img6_68 from './assets/projects/Facset AARAMBH 2023/NAR07896.jpg';
import img6_69 from './assets/projects/Facset AARAMBH 2023/NAR07947.jpg';
import img6_70 from './assets/projects/Facset AARAMBH 2023/NAR07987.jpg';
import img6_71 from './assets/projects/Facset AARAMBH 2023/NAR07997.jpg';
import img6_72 from './assets/projects/Facset AARAMBH 2023/NAR08001.jpg';
import img6_73 from './assets/projects/Facset AARAMBH 2023/NAR08009.jpg';
import img6_74 from './assets/projects/Facset AARAMBH 2023/NAR08097.jpg';
import img6_75 from './assets/projects/Facset AARAMBH 2023/NAR08129.jpg';
import img6_76 from './assets/projects/Facset AARAMBH 2023/NAR08135.jpg';
import img6_77 from './assets/projects/Facset AARAMBH 2023/NAR08363.jpg';
import img6_78 from './assets/projects/Facset AARAMBH 2023/NAR08433.jpg';
import img6_79 from './assets/projects/Facset AARAMBH 2023/NAR08489.jpg';
import img6_80 from './assets/projects/Facset AARAMBH 2023/caseStud-c1.png';
import img6_81 from './assets/projects/Facset AARAMBH 2023/caseStud-c2.jpg';
import img6_82 from './assets/projects/Facset AARAMBH 2023/caseStud-c2.png';
import img6_83 from './assets/projects/Facset AARAMBH 2023/caseStud-c3.jpg';
import img6_84 from './assets/projects/Facset AARAMBH 2023/caseStud-c4.jpg';
import img6_85 from './assets/projects/Facset AARAMBH 2023/caseStud-e1.jpg';
import img6_86 from './assets/projects/Facset AARAMBH 2023/caseStud-e2.jpg';
import img6_87 from './assets/projects/Facset AARAMBH 2023/caseStud-e3.jpg';
import img6_88 from './assets/projects/Facset AARAMBH 2023/caseStud-e4.jpg';


import img7_1 from './assets/projects/Facset Blockbuster 2019/239A8763.jpg'
import img7_2 from './assets/projects/Facset Blockbuster 2019/239A8777.jpg'
import img7_3 from './assets/projects/Facset Blockbuster 2019/239A8789.jpg'
import img7_4 from './assets/projects/Facset Blockbuster 2019/239A8802.jpg'
import img7_5 from './assets/projects/Facset Blockbuster 2019/239A8816.jpg'
import img7_6 from './assets/projects/Facset Blockbuster 2019/239A8819.jpg'
import img7_7 from './assets/projects/Facset Blockbuster 2019/239A9122.jpg'
import img7_8 from './assets/projects/Facset Blockbuster 2019/239A9281.jpg'
import img7_9 from './assets/projects/Facset Blockbuster 2019/239A9284.jpg'
import img7_10 from './assets/projects/Facset Blockbuster 2019/239A9428.jpg'
import img7_11 from './assets/projects/Facset Blockbuster 2019/JAY04122.jpg'
import img7_12 from './assets/projects/Facset Blockbuster 2019/JAY04153.jpg'
import img7_13 from './assets/projects/Facset Blockbuster 2019/JAY04197.jpg'
import img7_14 from './assets/projects/Facset Blockbuster 2019/_NUL2063.jpg'
import img7_15 from './assets/projects/Facset Blockbuster 2019/_NUL2168.jpg'
import img7_16 from './assets/projects/Facset Blockbuster 2019/_NUL2360.jpg'
import img7_17 from './assets/projects/Facset Blockbuster 2019/_NUL2414.jpg'
import img7_18 from './assets/projects/Facset Blockbuster 2019/_NUL2459.jpg'
import img7_19 from './assets/projects/Facset Blockbuster 2019/_NUL2535.jpg'
import img7_20 from './assets/projects/Facset Blockbuster 2019/_NUL2561.jpg'
import img7_21 from './assets/projects/Facset Blockbuster 2019/_NUL2588.jpg'
import img7_22 from './assets/projects/Facset Blockbuster 2019/_NUL2717.jpg'
import img7_23 from './assets/projects/Facset Blockbuster 2019/_NUL2764.jpg'
import img7_24 from './assets/projects/Facset Blockbuster 2019/_NUL2813.jpg'
import img7_25 from './assets/projects/Facset Blockbuster 2019/_NUL2825.jpg'
import img7_26 from './assets/projects/Facset Blockbuster 2019/_NUL2886.jpg'
import img7_27 from './assets/projects/Facset Blockbuster 2019/_NUL3082.jpg'
import img7_28 from './assets/projects/Facset Blockbuster 2019/_NUL3108.jpg'
import img7_29 from './assets/projects/Facset Blockbuster 2019/_NUL3109.jpg'
import img7_30 from './assets/projects/Facset Blockbuster 2019/_NUL3112.jpg'
import img7_31 from './assets/projects/Facset Blockbuster 2019/_NUL3490.jpg'
import img7_32 from './assets/projects/Facset Blockbuster 2019/_NUL3613.jpg'




import img8_1 from './assets/projects/Facset Blockbuster 2024/DSC05016.jpg'
import img8_2 from './assets/projects/Facset Blockbuster 2024/DSC05019.jpg'
import img8_3 from './assets/projects/Facset Blockbuster 2024/DSC05035.jpg'
import img8_4 from './assets/projects/Facset Blockbuster 2024/DSC05037.jpg'
import img8_5 from './assets/projects/Facset Blockbuster 2024/DSC05079.jpg'
import img8_6 from './assets/projects/Facset Blockbuster 2024/DSC05090.jpg'
import img8_7 from './assets/projects/Facset Blockbuster 2024/DSC05121.jpg'
import img8_8 from './assets/projects/Facset Blockbuster 2024/DSC05155-2.jpg'
import img8_9 from './assets/projects/Facset Blockbuster 2024/DSC05239.jpg'
import img8_10 from './assets/projects/Facset Blockbuster 2024/DSC05733.jpg'
import img8_11 from './assets/projects/Facset Blockbuster 2024/DSC05777.jpg'
import img8_12 from './assets/projects/Facset Blockbuster 2024/DSC05837.jpg'
import img8_13 from './assets/projects/Facset Blockbuster 2024/DSC05869.jpg'
import img8_14 from './assets/projects/Facset Blockbuster 2024/DSC05898.jpg'
import img8_15 from './assets/projects/Facset Blockbuster 2024/DSC06174.jpg'
import img8_16 from './assets/projects/Facset Blockbuster 2024/DSC06252.jpg'
import img8_17 from './assets/projects/Facset Blockbuster 2024/DSC06279.jpg'
import img8_18 from './assets/projects/Facset Blockbuster 2024/DSC06306.jpg'
import img8_19 from './assets/projects/Facset Blockbuster 2024/DSC06511.jpg'
import img8_20 from './assets/projects/Facset Blockbuster 2024/DSC06513.jpg'
import img8_21 from './assets/projects/Facset Blockbuster 2024/DSC06523.jpg'
import img8_22 from './assets/projects/Facset Blockbuster 2024/DSC06529.jpg'
import img8_23 from './assets/projects/Facset Blockbuster 2024/DSC06569.jpg'
import img8_24 from './assets/projects/Facset Blockbuster 2024/DSC06601.jpg'
import img8_25 from './assets/projects/Facset Blockbuster 2024/DSC06619.jpg'
import img8_26 from './assets/projects/Facset Blockbuster 2024/DSC06628.jpg'
import img8_27 from './assets/projects/Facset Blockbuster 2024/DSC06684.jpg'
import img8_28 from './assets/projects/Facset Blockbuster 2024/DSC06757.jpg'
import img8_29 from './assets/projects/Facset Blockbuster 2024/DSC06764.jpg'
import img8_30 from './assets/projects/Facset Blockbuster 2024/DSC06770.jpg'
import img8_31 from './assets/projects/Facset Blockbuster 2024/DSC06846.jpg';
import img8_32 from './assets/projects/Facset Blockbuster 2024/DSC06871.jpg';
import img8_33 from './assets/projects/Facset Blockbuster 2024/DSC06910.jpg';
import img8_34 from './assets/projects/Facset Blockbuster 2024/DSC06917.jpg';
import img8_35 from './assets/projects/Facset Blockbuster 2024/DSC06982.jpg';
import img8_36 from './assets/projects/Facset Blockbuster 2024/DSC06988.jpg';
import img8_37 from './assets/projects/Facset Blockbuster 2024/DSC06997.jpg';
import img8_38 from './assets/projects/Facset Blockbuster 2024/DSC07013.jpg';
import img8_39 from './assets/projects/Facset Blockbuster 2024/DSC07022.jpg';
import img8_40 from './assets/projects/Facset Blockbuster 2024/NAR00008.jpg';
import img8_41 from './assets/projects/Facset Blockbuster 2024/NAR00031.jpg';
import img8_42 from './assets/projects/Facset Blockbuster 2024/NAR00039.jpg';
import img8_43 from './assets/projects/Facset Blockbuster 2024/NAR00071.jpg';
import img8_44 from './assets/projects/Facset Blockbuster 2024/NAR00088.jpg';
import img8_45 from './assets/projects/Facset Blockbuster 2024/NAR00146.jpg';
import img8_46 from './assets/projects/Facset Blockbuster 2024/NAR00192.jpg';
import img8_47 from './assets/projects/Facset Blockbuster 2024/NAR00262.jpg';
import img8_48 from './assets/projects/Facset Blockbuster 2024/NAR00380.jpg';
import img8_49 from './assets/projects/Facset Blockbuster 2024/NAR00436.jpg';
import img8_50 from './assets/projects/Facset Blockbuster 2024/NAR00739.jpg';
import img8_51 from './assets/projects/Facset Blockbuster 2024/NAR00744.jpg';
import img8_52 from './assets/projects/Facset Blockbuster 2024/NAR00745.jpg';
import img8_53 from './assets/projects/Facset Blockbuster 2024/NAR00746.jpg';
import img8_54 from './assets/projects/Facset Blockbuster 2024/NAR00747.jpg';
import img8_55 from './assets/projects/Facset Blockbuster 2024/NAR00748.jpg';
import img8_56 from './assets/projects/Facset Blockbuster 2024/NAR00749.jpg';
import img8_57 from './assets/projects/Facset Blockbuster 2024/NAR00750.jpg';
import img8_58 from './assets/projects/Facset Blockbuster 2024/NAR00791.jpg';
import img8_59 from './assets/projects/Facset Blockbuster 2024/NAR00824.jpg';
import img8_60 from './assets/projects/Facset Blockbuster 2024/NAR00840.jpg';
import img8_61 from './assets/projects/Facset Blockbuster 2024/NAR09202.jpg';
import img8_62 from './assets/projects/Facset Blockbuster 2024/NAR09288.jpg';
import img8_63 from './assets/projects/Facset Blockbuster 2024/NAR09329.jpg';
import img8_64 from './assets/projects/Facset Blockbuster 2024/NAR09550.jpg';
import img8_65 from './assets/projects/Facset Blockbuster 2024/NAR09694.jpg';
import img8_66 from './assets/projects/Facset Blockbuster 2024/NAR09951.jpg';
import img8_67 from './assets/projects/Facset Blockbuster 2024/NAR09954.jpg';
import img8_68 from './assets/projects/Facset Blockbuster 2024/NAR09974.jpg';
import img8_69 from './assets/projects/Facset Blockbuster 2024/NAR09979.jpg';
import img8_70 from './assets/projects/Facset Blockbuster 2024/NAR09990.jpg';
import img8_71 from './assets/projects/Facset Blockbuster 2024/NAR09994.jpg';
import img8_72 from './assets/projects/Facset Blockbuster 2024/NAR09998.jpg';




import img9_1 from './assets/projects/Hyderabad City Police/CNU_8356.jpg'
import img9_2 from './assets/projects/Hyderabad City Police/CNU_8363.jpg'
import img9_3 from './assets/projects/Hyderabad City Police/CNU_8364.jpg'
import img9_4 from './assets/projects/Hyderabad City Police/CNU_8368.jpg'
import img9_5 from './assets/projects/Hyderabad City Police/CNU_8370.jpg'
import img9_6 from './assets/projects/Hyderabad City Police/CNU_8371.jpg'
import img9_7 from './assets/projects/Hyderabad City Police/CNU_8372.jpg'
import img9_8 from './assets/projects/Hyderabad City Police/CNU_8376.jpg'
import img9_9 from './assets/projects/Hyderabad City Police/CNU_8394.jpg'
import img9_10 from './assets/projects/Hyderabad City Police/CNU_8398.jpg'
import img9_11 from './assets/projects/Hyderabad City Police/CNU_8401.jpg'
import img9_12 from './assets/projects/Hyderabad City Police/CNU_8427.jpg'
import img9_13 from './assets/projects/Hyderabad City Police/CNU_8432.jpg'
import img9_14 from './assets/projects/Hyderabad City Police/CNU_8454.jpg'
import img9_15 from './assets/projects/Hyderabad City Police/CNU_8563.jpg'
import img9_16 from './assets/projects/Hyderabad City Police/CNU_8794.jpg'
import img9_17 from './assets/projects/Hyderabad City Police/CNU_8800.jpg'
import img9_18 from './assets/projects/Hyderabad City Police/CNU_8880.jpg'
import img9_19 from './assets/projects/Hyderabad City Police/CNU_8994.jpg'
import img9_20 from './assets/projects/Hyderabad City Police/CNU_9179.jpg'
import img9_21 from './assets/projects/Hyderabad City Police/CNU_9222.jpg'
import img9_22 from './assets/projects/Hyderabad City Police/CNU_9264.jpg'
import img9_23 from './assets/projects/Hyderabad City Police/CNU_9272.jpg'
import img9_24 from './assets/projects/Hyderabad City Police/CNU_9279.jpg'
import img9_25 from './assets/projects/Hyderabad City Police/CNU_9318.jpg'


import img10_1 from './assets/projects/Invesco Family Day/CNU_9446.jpg'
import img10_2 from './assets/projects/Invesco Family Day/CNU_9562.jpg'
import img10_3 from './assets/projects/Invesco Family Day/_R5A3467.jpg'
import img10_4 from './assets/projects/Invesco Family Day/_R5A3480.jpg'
import img10_5 from './assets/projects/Invesco Family Day/_R5A3528.jpg'
import img10_6 from './assets/projects/Invesco Family Day/_R5A3543.jpg'
import img10_7 from './assets/projects/Invesco Family Day/_R5A3553.jpg'
import img10_8 from './assets/projects/Invesco Family Day/_R5A3665.jpg'
import img10_9 from './assets/projects/Invesco Family Day/_R5A3723.jpg'
import img10_10 from './assets/projects/Invesco Family Day/_R5A3779.jpg'
import img10_11 from './assets/projects/Invesco Family Day/_R5A3792.jpg'
import img10_12 from './assets/projects/Invesco Family Day/_R5A3799.jpg'
import img10_13 from './assets/projects/Invesco Family Day/_R5A3829.jpg'
import img10_14 from './assets/projects/Invesco Family Day/_R5A3853.jpg'
import img10_15 from './assets/projects/Invesco Family Day/_R5A3868.jpg'
import img10_16 from './assets/projects/Invesco Family Day/_R5A3932.jpg'
import img10_17 from './assets/projects/Invesco Family Day/_R5A4061.jpg'
import img10_18 from './assets/projects/Invesco Family Day/_R5A4066.jpg'


import img11_1 from './assets/projects/MassMutual kids Carnival/A09A6397.jpg'
import img11_2 from './assets/projects/MassMutual kids Carnival/A09A6402.jpg'
import img11_3 from './assets/projects/MassMutual kids Carnival/A09A6408.jpg'
import img11_4 from './assets/projects/MassMutual kids Carnival/A09A6439.jpg'
import img11_5 from './assets/projects/MassMutual kids Carnival/A09A6448.jpg'
import img11_6 from './assets/projects/MassMutual kids Carnival/A09A6485.jpg'
import img11_7 from './assets/projects/MassMutual kids Carnival/A09A6534.jpg'
import img11_8 from './assets/projects/MassMutual kids Carnival/A09A6613.jpg'
import img11_9 from './assets/projects/MassMutual kids Carnival/A09A6614.jpg'
import img11_10 from './assets/projects/MassMutual kids Carnival/A09A6667.jpg'
import img11_11 from './assets/projects/MassMutual kids Carnival/A09A6668.jpg'
import img11_12 from './assets/projects/MassMutual kids Carnival/A09A6674.jpg'
import img11_13 from './assets/projects/MassMutual kids Carnival/A09A6855.jpg'
import img11_14 from './assets/projects/MassMutual kids Carnival/A09A6858.jpg'
import img11_15 from './assets/projects/MassMutual kids Carnival/A09A7114.jpg'
import img11_16 from './assets/projects/MassMutual kids Carnival/A09A7432.jpg'



import img12_1 from './assets/projects/MassMutual Pulse 2023/DSC00012.jpg'
import img12_2 from './assets/projects/MassMutual Pulse 2023/DSC00155.jpg'
import img12_3 from './assets/projects/MassMutual Pulse 2023/DSC00183.jpg'
import img12_4 from './assets/projects/MassMutual Pulse 2023/DSC00211.jpg'
import img12_5 from './assets/projects/MassMutual Pulse 2023/DSC00281.jpg'
import img12_6 from './assets/projects/MassMutual Pulse 2023/DSC00342.jpg'
import img12_7 from './assets/projects/MassMutual Pulse 2023/DSC00426.jpg'
import img12_8 from './assets/projects/MassMutual Pulse 2023/DSC00514.jpg'
import img12_9 from './assets/projects/MassMutual Pulse 2023/DSC00631.jpg'
import img12_10 from './assets/projects/MassMutual Pulse 2023/DSC00739.jpg'
import img12_11 from './assets/projects/MassMutual Pulse 2023/DSC00799.jpg'
import img12_12 from './assets/projects/MassMutual Pulse 2023/DSC00831.jpg'
import img12_13 from './assets/projects/MassMutual Pulse 2023/DSC01066.jpg'
import img12_14 from './assets/projects/MassMutual Pulse 2023/DSC01103.jpg'
import img12_15 from './assets/projects/MassMutual Pulse 2023/DSC01129.jpg'
import img12_16 from './assets/projects/MassMutual Pulse 2023/DSC01130.jpg'
import img12_17 from './assets/projects/MassMutual Pulse 2023/DSC01137.jpg'
import img12_18 from './assets/projects/MassMutual Pulse 2023/DSC01138.jpg'
import img12_19 from './assets/projects/MassMutual Pulse 2023/DSC01140.jpg'
import img12_20 from './assets/projects/MassMutual Pulse 2023/DSC01147.jpg'
import img12_21 from './assets/projects/MassMutual Pulse 2023/DSC01150.jpg'
import img12_22 from './assets/projects/MassMutual Pulse 2023/DSC01158.jpg'
import img12_23 from './assets/projects/MassMutual Pulse 2023/DSC01353.jpg'
import img12_24 from './assets/projects/MassMutual Pulse 2023/DSC01398.jpg'
import img12_25 from './assets/projects/MassMutual Pulse 2023/DSC01459.jpg'
import img12_26 from './assets/projects/MassMutual Pulse 2023/DSC01483.jpg'
import img12_27 from './assets/projects/MassMutual Pulse 2023/DSC01496.jpg'
import img12_28 from './assets/projects/MassMutual Pulse 2023/DSC01628.jpg'
import img12_29 from './assets/projects/MassMutual Pulse 2023/DSC01636.jpg'
import img12_30 from './assets/projects/MassMutual Pulse 2023/DSC01680.jpg'
import img12_31 from './assets/projects/MassMutual Pulse 2023/DSC01700.jpg';
import img12_32 from './assets/projects/MassMutual Pulse 2023/DSC01720.jpg';
import img12_33 from './assets/projects/MassMutual Pulse 2023/DSC01740.jpg';
import img12_34 from './assets/projects/MassMutual Pulse 2023/DSC01772.jpg';
import img12_35 from './assets/projects/MassMutual Pulse 2023/DSC01780.jpg';
import img12_36 from './assets/projects/MassMutual Pulse 2023/DSC01964.jpg';
import img12_37 from './assets/projects/MassMutual Pulse 2023/DSC01968.jpg';
import img12_38 from './assets/projects/MassMutual Pulse 2023/DSC01999.jpg';
import img12_39 from './assets/projects/MassMutual Pulse 2023/DSC02036.jpg';
import img12_40 from './assets/projects/MassMutual Pulse 2023/DSC02236.jpg';
import img12_41 from './assets/projects/MassMutual Pulse 2023/NAR07951.jpg';
import img12_42 from './assets/projects/MassMutual Pulse 2023/NAR07955.jpg';
import img12_43 from './assets/projects/MassMutual Pulse 2023/NAR07968.jpg';
import img12_44 from './assets/projects/MassMutual Pulse 2023/NAR07980.jpg';
import img12_45 from './assets/projects/MassMutual Pulse 2023/NAR08234.jpg';
import img12_46 from './assets/projects/MassMutual Pulse 2023/NAR08717.jpg';
import img12_47 from './assets/projects/MassMutual Pulse 2023/NAR08729.jpg';
import img12_48 from './assets/projects/MassMutual Pulse 2023/NAR08741.jpg';
import img12_49 from './assets/projects/MassMutual Pulse 2023/NAR09167.jpg';
import img12_50 from './assets/projects/MassMutual Pulse 2023/NAR09651.jpg';
import img12_51 from './assets/projects/MassMutual Pulse 2023/NAR09721.jpg';
import img12_52 from './assets/projects/MassMutual Pulse 2023/NAR09829.jpg';
import img12_53 from './assets/projects/MassMutual Pulse 2023/NAR09845.jpg';
import img12_54 from './assets/projects/MassMutual Pulse 2023/NAR09949.jpg';



import img13_1 from './assets/projects/MassMutual Sangam/DSC06588.jpg'
import img13_2 from './assets/projects/MassMutual Sangam/DSC06603.jpg'
import img13_3 from './assets/projects/MassMutual Sangam/DSC06623.jpg'
import img13_4 from './assets/projects/MassMutual Sangam/DSC06633.jpg'
import img13_5 from './assets/projects/MassMutual Sangam/DSC06641.jpg'
import img13_6 from './assets/projects/MassMutual Sangam/DSC06651.jpg'
import img13_7 from './assets/projects/MassMutual Sangam/DSC06746.jpg'
import img13_8 from './assets/projects/MassMutual Sangam/DSC06787.jpg'
import img13_9 from './assets/projects/MassMutual Sangam/DSC06815.jpg'
import img13_10 from './assets/projects/MassMutual Sangam/DSC06816.jpg'
import img13_11 from './assets/projects/MassMutual Sangam/DSC06830.jpg'
import img13_12 from './assets/projects/MassMutual Sangam/DSC06848.jpg'
import img13_13 from './assets/projects/MassMutual Sangam/DSC06854.jpg'
import img13_14 from './assets/projects/MassMutual Sangam/DSC06857.jpg'
import img13_15 from './assets/projects/MassMutual Sangam/DSC07181.jpg'
import img13_16 from './assets/projects/MassMutual Sangam/DSC07240.jpg'
import img13_17 from './assets/projects/MassMutual Sangam/DSC07249.jpg'
import img13_18 from './assets/projects/MassMutual Sangam/DSC07251.jpg'
import img13_19 from './assets/projects/MassMutual Sangam/DSC07252.jpg'
import img13_20 from './assets/projects/MassMutual Sangam/DSC07301.jpg'
import img13_21 from './assets/projects/MassMutual Sangam/DSC07432.jpg'
import img13_22 from './assets/projects/MassMutual Sangam/DSC07442.jpg'
import img13_23 from './assets/projects/MassMutual Sangam/DSC07444.jpg'
import img13_24 from './assets/projects/MassMutual Sangam/DSC07495.jpg'
import img13_25 from './assets/projects/MassMutual Sangam/DSC07536.jpg'
import img13_26 from './assets/projects/MassMutual Sangam/DSC07557.jpg'
import img13_27 from './assets/projects/MassMutual Sangam/DSC07614.jpg'
import img13_28 from './assets/projects/MassMutual Sangam/DSC07882.jpg'
import img13_29 from './assets/projects/MassMutual Sangam/DSC08029.jpg'
import img13_30 from './assets/projects/MassMutual Sangam/DSC08056.jpg'
import img13_31 from './assets/projects/MassMutual Sangam/DSC08067.jpg';
import img13_32 from './assets/projects/MassMutual Sangam/DSC08099.jpg';
import img13_33 from './assets/projects/MassMutual Sangam/DSC08123.jpg';
import img13_34 from './assets/projects/MassMutual Sangam/DSC08203.jpg';
import img13_35 from './assets/projects/MassMutual Sangam/DSC08243.jpg';
import img13_36 from './assets/projects/MassMutual Sangam/NAR00085.jpg';
import img13_37 from './assets/projects/MassMutual Sangam/NAR00095.jpg';
import img13_38 from './assets/projects/MassMutual Sangam/NAR00123.jpg';
import img13_39 from './assets/projects/MassMutual Sangam/NAR00270.jpg';
import img13_40 from './assets/projects/MassMutual Sangam/NAR00434.jpg';
import img13_41 from './assets/projects/MassMutual Sangam/NAR00438.jpg';
import img13_42 from './assets/projects/MassMutual Sangam/NAR00636.jpg';
import img13_43 from './assets/projects/MassMutual Sangam/NAR00658.jpg';
import img13_44 from './assets/projects/MassMutual Sangam/NAR00778.jpg';
import img13_45 from './assets/projects/MassMutual Sangam/NAR00830.jpg';
import img13_46 from './assets/projects/MassMutual Sangam/NAR00905.jpg';
import img13_47 from './assets/projects/MassMutual Sangam/NAR00993.jpg';
import img13_48 from './assets/projects/MassMutual Sangam/NAR01060.jpg';




import img14_1 from './assets/projects/MassMutual_Beyond Horizon/A09A2884.jpg'
import img14_2 from './assets/projects/MassMutual_Beyond Horizon/A09A2887.jpg'
import img14_3 from './assets/projects/MassMutual_Beyond Horizon/A09A2921.jpg'
import img14_4 from './assets/projects/MassMutual_Beyond Horizon/A09A2936.jpg'
import img14_5 from './assets/projects/MassMutual_Beyond Horizon/A09A2977.jpg'
import img14_6 from './assets/projects/MassMutual_Beyond Horizon/A09A2996.jpg'
import img14_7 from './assets/projects/MassMutual_Beyond Horizon/A09A3000.jpg'
import img14_8 from './assets/projects/MassMutual_Beyond Horizon/A09A3005.jpg'
import img14_9 from './assets/projects/MassMutual_Beyond Horizon/A09A3028.jpg'
import img14_10 from './assets/projects/MassMutual_Beyond Horizon/A09A3355.jpg'
import img14_11 from './assets/projects/MassMutual_Beyond Horizon/A09A3362.jpg'
import img14_12 from './assets/projects/MassMutual_Beyond Horizon/A09A3374.jpg'
import img14_13 from './assets/projects/MassMutual_Beyond Horizon/A09A3486.jpg'
import img14_14 from './assets/projects/MassMutual_Beyond Horizon/A09A3494.jpg'
import img14_15 from './assets/projects/MassMutual_Beyond Horizon/A09A3530.jpg'
import img14_16 from './assets/projects/MassMutual_Beyond Horizon/A09A3582.jpg'
import img14_17 from './assets/projects/MassMutual_Beyond Horizon/A09A3683.jpg'
import img14_18 from './assets/projects/MassMutual_Beyond Horizon/A09A3703.jpg'
import img14_19 from './assets/projects/MassMutual_Beyond Horizon/A09A3751.jpg'
import img14_20 from './assets/projects/MassMutual_Beyond Horizon/A09A3832.jpg'
import img14_21 from './assets/projects/MassMutual_Beyond Horizon/A09A4081.jpg'
import img14_22 from './assets/projects/MassMutual_Beyond Horizon/A09A4093.jpg'
import img14_23 from './assets/projects/MassMutual_Beyond Horizon/A09A4105.jpg'
import img14_24 from './assets/projects/MassMutual_Beyond Horizon/A09A4204.jpg'
import img14_25 from './assets/projects/MassMutual_Beyond Horizon/A09A4536.jpg'
import img14_26 from './assets/projects/MassMutual_Beyond Horizon/A09A4634.jpg'
import img14_27 from './assets/projects/MassMutual_Beyond Horizon/A09A4711.jpg'
import img14_28 from './assets/projects/MassMutual_Beyond Horizon/A09A4732.jpg'
import img14_29 from './assets/projects/MassMutual_Beyond Horizon/A09A4905.jpg'
import img14_30 from './assets/projects/MassMutual_Beyond Horizon/JG_02573.jpg'
import img14_31 from './assets/projects/MassMutual_Beyond Horizon/JG_02586.jpg';
import img14_32 from './assets/projects/MassMutual_Beyond Horizon/JG_02587.jpg';
import img14_33 from './assets/projects/MassMutual_Beyond Horizon/JG_02612.jpg';
import img14_34 from './assets/projects/MassMutual_Beyond Horizon/JG_02622.jpg';
import img14_35 from './assets/projects/MassMutual_Beyond Horizon/JG_02652.jpg';
import img14_36 from './assets/projects/MassMutual_Beyond Horizon/JG_03104.jpg';
import img14_37 from './assets/projects/MassMutual_Beyond Horizon/JG_03184.jpg';
import img14_38 from './assets/projects/MassMutual_Beyond Horizon/JG_03871.jpg';
import img14_39 from './assets/projects/MassMutual_Beyond Horizon/NAR09794.jpg';
import img14_40 from './assets/projects/MassMutual_Beyond Horizon/NAR09809.jpg';




import img15_1 from './assets/projects/MassMutual_LeadershipMeet/JG_01775.jpg'
import img15_2 from './assets/projects/MassMutual_LeadershipMeet/JG_01800.jpg'
import img15_3 from './assets/projects/MassMutual_LeadershipMeet/JG_01837.jpg'
import img15_4 from './assets/projects/MassMutual_LeadershipMeet/JG_01864.jpg'
import img15_5 from './assets/projects/MassMutual_LeadershipMeet/JG_01867.jpg'
import img15_6 from './assets/projects/MassMutual_LeadershipMeet/JG_01989.jpg'
import img15_7 from './assets/projects/MassMutual_LeadershipMeet/JG_02034.jpg'
import img15_8 from './assets/projects/MassMutual_LeadershipMeet/JG_02097.jpg'
import img15_9 from './assets/projects/MassMutual_LeadershipMeet/JG_02137.jpg'
import img15_10 from './assets/projects/MassMutual_LeadershipMeet/NAR08820.jpg'
import img15_11 from './assets/projects/MassMutual_LeadershipMeet/NAR08823.jpg'
import img15_12 from './assets/projects/MassMutual_LeadershipMeet/NAR08864.jpg'
import img15_13 from './assets/projects/MassMutual_LeadershipMeet/NAR08869.jpg'
import img15_14 from './assets/projects/MassMutual_LeadershipMeet/NAR08885.jpg'
import img15_15 from './assets/projects/MassMutual_LeadershipMeet/NAR08893.jpg'
import img15_16 from './assets/projects/MassMutual_LeadershipMeet/NAR08899.jpg'
import img15_17 from './assets/projects/MassMutual_LeadershipMeet/NAR08908.jpg'
import img15_18 from './assets/projects/MassMutual_LeadershipMeet/NAR08917.jpg'
import img15_19 from './assets/projects/MassMutual_LeadershipMeet/NAR08930.jpg'
import img15_20 from './assets/projects/MassMutual_LeadershipMeet/NAR08980.jpg'
import img15_21 from './assets/projects/MassMutual_LeadershipMeet/NAR09032.jpg'
import img15_22 from './assets/projects/MassMutual_LeadershipMeet/NAR09083.jpg'
import img15_23 from './assets/projects/MassMutual_LeadershipMeet/NAR09177.jpg'
import img15_24 from './assets/projects/MassMutual_LeadershipMeet/NAR09204.jpg'
import img15_25 from './assets/projects/MassMutual_LeadershipMeet/NAR09243.jpg'
import img15_26 from './assets/projects/MassMutual_LeadershipMeet/NAR09255.jpg'
import img15_27 from './assets/projects/MassMutual_LeadershipMeet/NAR09468.jpg'
import img15_28 from './assets/projects/MassMutual_LeadershipMeet/NAR09504.jpg'
import img15_29 from './assets/projects/MassMutual_LeadershipMeet/NAR09513.jpg'
import img15_30 from './assets/projects/MassMutual_LeadershipMeet/NAR09514.jpg'
import img15_31 from './assets/projects/MassMutual_LeadershipMeet/NAR09579.jpg'
import img15_32 from './assets/projects/MassMutual_LeadershipMeet/NAR09585.jpg'
import img15_33 from './assets/projects/MassMutual_LeadershipMeet/NAR09703.jpg'
import img15_34 from './assets/projects/MassMutual_LeadershipMeet/NAR09711.jpg'



import img16_1 from './assets/projects/Rimini Street 10 Years Celebrations/DJI_0054.MOV.00_02_10_13.Still001.jpg'
import img16_2 from './assets/projects/Rimini Street 10 Years Celebrations/DJI_0054.MOV.00_02_14_15.Still002.jpg'
import img16_3 from './assets/projects/Rimini Street 10 Years Celebrations/DJI_0082.jpg'
import img16_4 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01120.jpg'
import img16_5 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01127.jpg'
import img16_6 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01132.jpg'
import img16_7 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01140.jpg'
import img16_8 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01149.jpg'
import img16_9 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01151.jpg'
import img16_10 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01168.jpg'
import img16_11 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01181.jpg'
import img16_12 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01271.jpg'
import img16_13 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01280.jpg'
import img16_14 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01282.jpg'
import img16_15 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01474.jpg'
import img16_16 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01488.jpg'
import img16_17 from './assets/projects/Rimini Street 10 Years Celebrations/DSC01499.jpg'
import img16_18 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02048.jpg'
import img16_19 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02068.jpg'
import img16_20 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02129.jpg'
import img16_21 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02176.jpg'
import img16_22 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02204.jpg'
import img16_23 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02319.jpg'
import img16_24 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02514.jpg'
import img16_25 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02794.jpg'
import img16_26 from './assets/projects/Rimini Street 10 Years Celebrations/DSC02842.jpg'
import img16_27 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03004.jpg'
import img16_28 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03072.jpg'
import img16_29 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03218.jpg'
import img16_30 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03254.jpg'
import img16_31 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03255.jpg';
import img16_32 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03264.jpg';
import img16_33 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03311.jpg';
import img16_34 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03356.jpg';
import img16_35 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03372.jpg';
import img16_36 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03388.jpg';
import img16_37 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03407.jpg';
import img16_38 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03423.jpg';
import img16_39 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03469.jpg';
import img16_40 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03503.jpg';
import img16_41 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03515.jpg';
import img16_42 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03533.jpg';
import img16_43 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03854.jpg';
import img16_44 from './assets/projects/Rimini Street 10 Years Celebrations/DSC03879.jpg';
import img16_45 from './assets/projects/Rimini Street 10 Years Celebrations/Event_Glmpses_Final.00_04_28_13.Still001.jpg';
import img16_46 from './assets/projects/Rimini Street 10 Years Celebrations/NAR00287.jpg';
import img16_47 from './assets/projects/Rimini Street 10 Years Celebrations/NAR00323.jpg';
import img16_48 from './assets/projects/Rimini Street 10 Years Celebrations/NAR00874.jpg';




import img17_1 from './assets/projects/S&P Global/528A0030.jpg'
import img17_2 from './assets/projects/S&P Global/528A6816.jpg'
import img17_3 from './assets/projects/S&P Global/528A6823-2.jpg'
import img17_4 from './assets/projects/S&P Global/528A6823.jpg'
import img17_5 from './assets/projects/S&P Global/528A6835.jpg'
import img17_6 from './assets/projects/S&P Global/528A6838.jpg'
import img17_7 from './assets/projects/S&P Global/528A6840.jpg'
import img17_8 from './assets/projects/S&P Global/528A6885-2.jpg'
import img17_9 from './assets/projects/S&P Global/528A6885.jpg'
import img17_10 from './assets/projects/S&P Global/528A6887.jpg'
import img17_11 from './assets/projects/S&P Global/528A6893.jpg'
import img17_12 from './assets/projects/S&P Global/528A6895-2.jpg'
import img17_13 from './assets/projects/S&P Global/528A6895.jpg'
import img17_14 from './assets/projects/S&P Global/528A6904.jpg'
import img17_15 from './assets/projects/S&P Global/528A6906.jpg'
import img17_16 from './assets/projects/S&P Global/528A6972.jpg'
import img17_17 from './assets/projects/S&P Global/528A7005.jpg'
import img17_18 from './assets/projects/S&P Global/528A7008.jpg'
import img17_19 from './assets/projects/S&P Global/528A7148.jpg'
import img17_20 from './assets/projects/S&P Global/528A7193.jpg'
import img17_21 from './assets/projects/S&P Global/528A7395.jpg'
import img17_22 from './assets/projects/S&P Global/528A7414.jpg'
import img17_23 from './assets/projects/S&P Global/528A7490.jpg'
import img17_24 from './assets/projects/S&P Global/528A7504.jpg'
import img17_25 from './assets/projects/S&P Global/528A7583.jpg'
import img17_26 from './assets/projects/S&P Global/528A7609.jpg'
import img17_27 from './assets/projects/S&P Global/528A9131.jpg'
import img17_28 from './assets/projects/S&P Global/528A9231.jpg'
import img17_29 from './assets/projects/S&P Global/528A9236.jpg'
import img17_30 from './assets/projects/S&P Global/528A9323.jpg'
import img17_31 from './assets/projects/S&P Global/528A9492.jpg';
import img17_32 from './assets/projects/S&P Global/528A9493.jpg';
import img17_33 from './assets/projects/S&P Global/528A9502.jpg';
import img17_34 from './assets/projects/S&P Global/528A9878.jpg';
import img17_35 from './assets/projects/S&P Global/ZOOM5611.jpg';
import img17_36 from './assets/projects/S&P Global/ZOOM5622.jpg';
import img17_37 from './assets/projects/S&P Global/ZOOM5626.jpg';
import img17_38 from './assets/projects/S&P Global/ZOOM5681.jpg';
import img17_39 from './assets/projects/S&P Global/ZOOM5683.jpg';
import img17_40 from './assets/projects/S&P Global/ZOOM5689.jpg';
import img17_41 from './assets/projects/S&P Global/ZOOM5694.jpg';
import img17_42 from './assets/projects/S&P Global/ZOOM5702.jpg';
import img17_43 from './assets/projects/S&P Global/ZOOM5706.jpg';
import img17_44 from './assets/projects/S&P Global/ZOOM5729.jpg';
import img17_45 from './assets/projects/S&P Global/ZOOM5736.jpg';
import img17_46 from './assets/projects/S&P Global/ZOOM5737.jpg';
import img17_47 from './assets/projects/S&P Global/ZOOM5742.jpg';
import img17_48 from './assets/projects/S&P Global/ZOOM5755.jpg';
import img17_49 from './assets/projects/S&P Global/ZOOM5762.jpg';
import img17_50 from './assets/projects/S&P Global/ZOOM5763.jpg';
import img17_51 from './assets/projects/S&P Global/ZOOM5773.jpg';
import img17_52 from './assets/projects/S&P Global/ZOOM5775.jpg';
import img17_53 from './assets/projects/S&P Global/ZOOM5844.jpg';
import img17_54 from './assets/projects/S&P Global/ZOOM5937.jpg';



import img18_1 from './assets/projects/S&P Global gala celebrations/528A0006.jpg'
import img18_2 from './assets/projects/S&P Global gala celebrations/528A0017.jpg'
import img18_3 from './assets/projects/S&P Global gala celebrations/528A0030.jpg'
import img18_4 from './assets/projects/S&P Global gala celebrations/528A0031.jpg'
import img18_5 from './assets/projects/S&P Global gala celebrations/528A0052.jpg'
import img18_6 from './assets/projects/S&P Global gala celebrations/528A0112.jpg'
import img18_7 from './assets/projects/S&P Global gala celebrations/528A0114.jpg'
import img18_8 from './assets/projects/S&P Global gala celebrations/528A9739.jpg'
import img18_9 from './assets/projects/S&P Global gala celebrations/528A9757.jpg'
import img18_10 from './assets/projects/S&P Global gala celebrations/528A9796.jpg'
import img18_11 from './assets/projects/S&P Global gala celebrations/528A9876.jpg'
import img18_12 from './assets/projects/S&P Global gala celebrations/528A9878.jpg'
import img18_13 from './assets/projects/S&P Global gala celebrations/528A9881.jpg'
import img18_14 from './assets/projects/S&P Global gala celebrations/528A9915.jpg'
import img18_15 from './assets/projects/S&P Global gala celebrations/7K7A0051.jpg'
import img18_16 from './assets/projects/S&P Global gala celebrations/7K7A0112.jpg'
import img18_17 from './assets/projects/S&P Global gala celebrations/ZOOM5611.jpg'
import img18_18 from './assets/projects/S&P Global gala celebrations/ZOOM5705.jpg'
import img18_19 from './assets/projects/S&P Global gala celebrations/ZOOM5729.jpg'
import img18_20 from './assets/projects/S&P Global gala celebrations/ZOOM5735.jpg'
import img18_21 from './assets/projects/S&P Global gala celebrations/ZOOM5749.jpg'
import img18_22 from './assets/projects/S&P Global gala celebrations/ZOOM5750.jpg'
import img18_23 from './assets/projects/S&P Global gala celebrations/ZOOM5755.jpg'
import img18_24 from './assets/projects/S&P Global gala celebrations/ZOOM5762.jpg'
import img18_25 from './assets/projects/S&P Global gala celebrations/ZOOM5763.jpg'
import img18_26 from './assets/projects/S&P Global gala celebrations/ZOOM5767.jpg'
import img18_27 from './assets/projects/S&P Global gala celebrations/ZOOM5791.jpg'
import img18_28 from './assets/projects/S&P Global gala celebrations/ZOOM5807.jpg'
import img18_29 from './assets/projects/S&P Global gala celebrations/ZOOM5824.jpg'
import img18_30 from './assets/projects/S&P Global gala celebrations/ZOOM5833.jpg'
import img18_31 from './assets/projects/S&P Global gala celebrations/ZOOM5928.jpg';
import img18_32 from './assets/projects/S&P Global gala celebrations/ZOOM5935.jpg';
import img18_33 from './assets/projects/S&P Global gala celebrations/ZOOM5947.jpg';
import img18_34 from './assets/projects/S&P Global gala celebrations/ZOOM5951.jpg';
import img18_35 from './assets/projects/S&P Global gala celebrations/ZOOM5964.jpg';
import img18_36 from './assets/projects/S&P Global gala celebrations/ZOOM5968.jpg';
import img18_37 from './assets/projects/S&P Global gala celebrations/ZOOM5971.jpg';
import img18_38 from './assets/projects/S&P Global gala celebrations/ZOOM5977.jpg';
import img18_39 from './assets/projects/S&P Global gala celebrations/ZOOM5985.jpg';
import img18_40 from './assets/projects/S&P Global gala celebrations/ZOOM5992.jpg';
import img18_41 from './assets/projects/S&P Global gala celebrations/ZOOM5994.jpg';
import img18_42 from './assets/projects/S&P Global gala celebrations/ZOOM5999.jpg';
import img18_43 from './assets/projects/S&P Global gala celebrations/ZOOM6002.jpg';
import img18_44 from './assets/projects/S&P Global gala celebrations/ZOOM6008.jpg';
import img18_45 from './assets/projects/S&P Global gala celebrations/ZOOM6013.jpg';



import img19_1 from './assets/projects/She Team_Hyderabad City Police/CNU_8368.jpg'
import img19_2 from './assets/projects/She Team_Hyderabad City Police/CNU_8370.jpg'
import img19_3 from './assets/projects/She Team_Hyderabad City Police/CNU_8419.jpg'
import img19_4 from './assets/projects/She Team_Hyderabad City Police/CNU_8458.jpg'
import img19_5 from './assets/projects/She Team_Hyderabad City Police/CNU_8562.jpg'
import img19_6 from './assets/projects/She Team_Hyderabad City Police/CNU_8645.jpg'
import img19_7 from './assets/projects/She Team_Hyderabad City Police/CNU_8806.jpg'
import img19_8 from './assets/projects/She Team_Hyderabad City Police/CNU_9180.jpg'
import img19_9 from './assets/projects/She Team_Hyderabad City Police/CNU_9182.jpg'
import img19_10 from './assets/projects/She Team_Hyderabad City Police/CNU_9255.jpg'
import img19_11 from './assets/projects/She Team_Hyderabad City Police/CNU_9266.jpg'
import img19_12 from './assets/projects/She Team_Hyderabad City Police/CNU_9270.jpg'


import img20_1 from './assets/projects/Value Labs Annual Event/IMG_0002.jpg'
import img20_2 from './assets/projects/Value Labs Annual Event/IMG_0018.jpg'
import img20_3 from './assets/projects/Value Labs Annual Event/IMG_0069.jpg'
import img20_4 from './assets/projects/Value Labs Annual Event/IMG_0162.jpg'
import img20_5 from './assets/projects/Value Labs Annual Event/IMG_0165.jpg'
import img20_6 from './assets/projects/Value Labs Annual Event/IMG_0176.jpg'
import img20_7 from './assets/projects/Value Labs Annual Event/IMG_0182.jpg'
import img20_8 from './assets/projects/Value Labs Annual Event/IMG_0194.jpg'
import img20_9 from './assets/projects/Value Labs Annual Event/IMG_0210.jpg'
import img20_10 from './assets/projects/Value Labs Annual Event/IMG_0222.jpg'
import img20_11 from './assets/projects/Value Labs Annual Event/IMG_0235.jpg'
import img20_12 from './assets/projects/Value Labs Annual Event/IMG_9340.jpg'
import img20_13 from './assets/projects/Value Labs Annual Event/IMG_9402.jpg'
import img20_14 from './assets/projects/Value Labs Annual Event/IMG_9440.jpg'
import img20_15 from './assets/projects/Value Labs Annual Event/IMG_9442.jpg'
import img20_16 from './assets/projects/Value Labs Annual Event/IMG_9471.jpg'
import img20_17 from './assets/projects/Value Labs Annual Event/IMG_9476.jpg'
import img20_18 from './assets/projects/Value Labs Annual Event/IMG_9478.jpg'
import img20_19 from './assets/projects/Value Labs Annual Event/IMG_9507.jpg'
import img20_20 from './assets/projects/Value Labs Annual Event/IMG_9688.jpg'
import img20_21 from './assets/projects/Value Labs Annual Event/IMG_9704.jpg'
import img20_22 from './assets/projects/Value Labs Annual Event/IMG_9758.jpg'
import img20_23 from './assets/projects/Value Labs Annual Event/IMG_9853.jpg'
import img20_24 from './assets/projects/Value Labs Annual Event/IMG_9877.jpg'
import img20_25 from './assets/projects/Value Labs Annual Event/IMG_9910.jpg'
import img20_26 from './assets/projects/Value Labs Annual Event/IMG_9922.jpg'
import img20_27 from './assets/projects/Value Labs Annual Event/IMG_9958.jpg'



import AOS from 'aos';
import 'aos/dist/aos.css';
import ProjectPhotos from './pages/ProjectPhotos';
import Testimonials from './pages/Testimonials';
import ProjectVideoCards from './pages/ProjectVideoCards';



const projects = {
  '1': {
    id: '1',
    title: "AVEVA CEC Launch",
    company: "",
    thumbnail: thumbnail1,
    imgs: [
      img1_1, img1_2, img1_3, img1_4, img1_5, 
      img1_6, img1_7, img1_8, img1_9, img1_10, 
      img1_11, img1_12, img1_13, img1_14, img1_15, 
      img1_16, img1_17, img1_18, img1_19, img1_20, 
      img1_21, img1_22, img1_23, img1_24, img1_25, 
      img1_26, img1_27, img1_28, img1_29, img1_30, 
      img1_31, img1_32, img1_33, img1_34, img1_35, 
      img1_36, img1_37, img1_38, img1_39, img1_40, 
      img1_41, img1_42, img1_43, img1_44, img1_45, 
      img1_46, img1_47, img1_48, img1_49
    ]    
  },
  '2': {
    id: '2',
    title: "CHUBB Hyderbad Inauguration",
    company: "",
    thumbnail: thumbnail2,
    imgs: [
      img2_1, img2_2, img2_3, img2_4, img2_5, 
      img2_6, img2_7, img2_8, img2_9, img2_10, 
      img2_11, img2_12, img2_13, img2_14, img2_15, 
      img2_16, img2_17, img2_18, img2_19, img2_20, 
      img2_21, img2_22, img2_23, img2_24, img2_25, 
      img2_26, img2_27
    ]
  },
  '3': {
    id: '3',
    title: "CHUBB Kids Carnival",
    company: "",
    thumbnail: thumbnail3,
    imgs: [
      img3_1, img3_2, img3_3, img3_4, img3_5, 
      img3_6, img3_7, img3_8, img3_9, img3_10, 
      img3_11, img3_12, img3_13, img3_14, img3_15, 
      img3_16, img3_17, img3_18, img3_19, img3_20
    ]
  },
  '4': {
    id: '4',
    title: "EVERNORTH LAUNCH",
    company: "",
    thumbnail: thumbnail4,
    imgs: [
      img4_1, img4_2, img4_3, img4_4, img4_5, 
      img4_6, img4_7, img4_8, img4_9, img4_10, 
      img4_11, img4_12, img4_13, img4_14, img4_15, 
      img4_16, img4_17, img4_18, img4_19, img4_20, 
      img4_21, img4_22, img4_23, img4_24, img4_25, 
      img4_26, img4_27, img4_28, img4_29, img4_30, 
      img4_31, img4_32, img4_33, img4_34, img4_35, 
      img4_36, img4_37, img4_38, img4_39, img4_40, 
      img4_41, img4_42, img4_43, img4_44, img4_45, 
      img4_46
    ]
    
  },
  '5': {
    id: '5',
    title: "EVERNORTH Celebrations",
    company: "",
    thumbnail: thumbnail5,
    imgs: [
      img5_1, img5_2, img5_3, img5_4, img5_5, 
      img5_6, img5_7, img5_8, img5_9, img5_10, img5_11, 
      img5_12, img5_13, img5_14, img5_15, img5_16, img5_17, 
      img5_18, img5_19, img5_20, img5_21, img5_22, img5_23, 
      img5_24, img5_25, img5_26, img5_27, img5_28, img5_29, img5_30, 
      img5_31, img5_32, img5_33, img5_34, img5_35, img5_36, 
      img5_37, img5_38, img5_39, img5_41, img5_42, 
      img5_43, img5_44, img5_45, img5_46, img5_47, img5_48, 
      img5_49, img5_50, img5_51, img5_52, img5_53, img5_54, 
      img5_55, img5_56, img5_57
    ]
    
  },
  '6': {
    id: '6',
    title: "Facset AARAMBH 2023",
    company: "",
    thumbnail: thumbnail6,
    imgs: [
      img6_1, img6_2, img6_3, img6_4, img6_5, 
      img6_6, img6_7, img6_8, img6_9, img6_10, 
      img6_11, img6_12, img6_13, img6_14, img6_15, 
      img6_16, img6_17, img6_18, img6_19, img6_20, 
      img6_21, img6_22, img6_23, img6_24, img6_25, 
      img6_26, img6_27, img6_28, img6_29, img6_30, 
      img6_31, img6_32, img6_33, img6_34, img6_35, img6_36, 
      img6_37, img6_38, img6_39, img6_40, img6_41, img6_42, 
      img6_43, img6_44, img6_45, img6_46, img6_47, img6_48, 
      img6_49, img6_50, img6_51, img6_52, img6_53, img6_54, 
      img6_55, img6_56, img6_57, img6_58, img6_59, img6_60, 
      img6_61, img6_62, img6_63, img6_64, img6_65, img6_66, 
      img6_67, img6_68, img6_69, img6_70, img6_71, img6_72, 
      img6_73, img6_74, img6_75, img6_76, img6_77, img6_78, 
      img6_79, img6_80, img6_81, img6_82, img6_83, img6_84, 
      img6_85, img6_86, img6_87, img6_88
    ]
    
  },
  '7': {
    id: '7',
    title: "Facset Blockbuster 2019",
    company: "",
    thumbnail: thumbnail7,
    imgs: [
      img7_1, img7_2, img7_3, img7_4, img7_5, 
      img7_6, img7_7, img7_8, img7_9, img7_10, 
      img7_11, img7_12, img7_13, img7_14, img7_15, 
      img7_16, img7_17, img7_18, img7_19, img7_20, 
      img7_21, img7_22, img7_23, img7_24, img7_25, 
      img7_26, img7_27, img7_28, img7_29, img7_30, 
      img7_31, img7_32
    ]
  },
  '8': {
    id: '8',
    title: "Facset Blockbuster 2024",
    company: "",
    thumbnail: thumbnail8,
    imgs: [
      img8_1, img8_2, img8_3, img8_4, img8_5, 
      img8_6, img8_7, img8_8, img8_9, img8_10, 
      img8_11, img8_12, img8_13, img8_14, img8_15, 
      img8_16, img8_17, img8_18, img8_19, img8_20, 
      img8_21, img8_22, img8_23, img8_24, img8_25, 
      img8_26, img8_27, img8_28, img8_29, img8_30, 
      img8_31, img8_32, img8_33, img8_34, img8_35, img8_36, 
      img8_37, img8_38, img8_39, img8_40, img8_41, img8_42, 
      img8_43, img8_44, img8_45, img8_46, img8_47, img8_48, 
      img8_49, img8_50, img8_51, img8_52, img8_53, img8_54, 
      img8_55, img8_56, img8_57, img8_58, img8_59, img8_60, 
      img8_61, img8_62, img8_63, img8_64, img8_65, img8_66, 
      img8_67, img8_68, img8_69, img8_70, img8_71, img8_72
    ]    
  },
  '9': {
    id: '9',
    title: "Hyderabad City Police",
    company: "",
    thumbnail: thumbnail9,
    imgs: [
      img9_1, img9_2, img9_3, img9_4, img9_5, 
      img9_6, img9_7, img9_8, img9_9, img9_10, 
      img9_11, img9_12, img9_13, img9_14, img9_15, 
      img9_16, img9_17, img9_18, img9_19, img9_20, 
      img9_21, img9_22, img9_23, img9_24, img9_25
    ]
  },
  '10': {
    id: '10',
    title: "Invesco Family Day",
    company: "",
    thumbnail: thumbnail10,
    imgs: [
      img10_1, img10_2, img10_3, img10_4, img10_5, 
      img10_6, img10_7, img10_8, img10_9, img10_10, 
      img10_11, img10_12, img10_13, img10_14, img10_15, 
      img10_16, img10_17, img10_18
    ]
  },
  '11': {
    id: '11',
    title: "MassMutual kids Carnival",
    company: "",
    thumbnail: thumbnail11,
    imgs: [
      img11_1, img11_2, img11_3, img11_4, img11_5, 
      img11_6, img11_7, img11_8, img11_9, img11_10, 
      img11_11, img11_12, img11_13, img11_14, img11_15, 
      img11_16
    ]
  },
  '12': {
    id: '12',
    title: "MassMutual Pulse 2023",
    company: "",
    thumbnail: thumbnail12,
    imgs: [
      img12_1, img12_2, img12_3, img12_4, img12_5, 
      img12_6, img12_7, img12_8, img12_9, img12_10, 
      img12_11, img12_12, img12_13, img12_14, img12_15, 
      img12_16, img12_17, img12_18, img12_19, img12_20, 
      img12_21, img12_22, img12_23, img12_24, img12_25, 
      img12_26, img12_27, img12_28, img12_29, img12_30, 
      img12_31, img12_32, img12_33, img12_34, img12_35, img12_36, 
      img12_37, img12_38, img12_39, img12_40, img12_41, img12_42, 
      img12_43, img12_44, img12_45, img12_46, img12_47, img12_48, 
      img12_49, img12_50, img12_51, img12_52, img12_53, img12_54
    ]
    
  },
  '13': {
    id: '13',
    title: "MassMutual Sangam",
    company: "",
    thumbnail: thumbnail13,
    imgs: [
      img13_1, img13_2, img13_3, img13_4, img13_5, 
      img13_6, img13_7, img13_8, img13_9, img13_10, 
      img13_11, img13_12, img13_13, img13_14, img13_15, 
      img13_16, img13_17, img13_18, img13_19, img13_20, 
      img13_21, img13_22, img13_23, img13_24, img13_25, 
      img13_26, img13_27, img13_28, img13_29, img13_30, 
      img13_31, img13_32, img13_33, img13_34, img13_35, img13_36, 
      img13_37, img13_38, img13_39, img13_40, img13_41, img13_42, 
      img13_43, img13_44, img13_45, img13_46, img13_47, img13_48
    ]
    
  },
  '14': {
    id: '14',
    title: "MassMutual Beyond Horizon",
    company: "",
    thumbnail: thumbnail14,
    imgs: [
      img14_1, img14_2, img14_3, img14_4, img14_5, 
      img14_6, img14_7, img14_8, img14_9, img14_10, 
      img14_11, img14_12, img14_13, img14_14, img14_15, 
      img14_16, img14_17, img14_18, img14_19, img14_20, 
      img14_21, img14_22, img14_23, img14_24, img14_25, 
      img14_26, img14_27, img14_28, img14_29, img14_30, 
      img14_31, img14_32, img14_33, img14_34, img14_35, img14_36, 
      img14_37, img14_38, img14_39, img14_40
    ]
    
  },
  '15': {
    id: '15',
    title: "MassMutual Leadership Meet",
    company: "",
    thumbnail: thumbnail15,
    imgs: [
      img15_1, img15_2, img15_3, img15_4, img15_5, 
      img15_6, img15_7, img15_8, img15_9, img15_10, 
      img15_11, img15_12, img15_13, img15_14, img15_15, 
      img15_16, img15_17, img15_18, img15_19, img15_20, 
      img15_21, img15_22, img15_23, img15_24, img15_25, 
      img15_26, img15_27, img15_28, img15_29, img15_30,
      img15_31, img15_32, img15_33, img15_34
    ]
  },
  '16': {
    id: '16',
    title: "Rimini Street 10 Years Celebrations",
    company: "",
    thumbnail: thumbnail16,
    imgs: [
      img16_1, img16_2, img16_3, img16_4, img16_5, 
      img16_6, img16_7, img16_8, img16_9, img16_10, 
      img16_11, img16_12, img16_13, img16_14, img16_15, 
      img16_16, img16_17, img16_18, img16_19, img16_20, 
      img16_21, img16_22, img16_23, img16_24, img16_25, 
      img16_26, img16_27, img16_28, img16_29, img16_30, 
      img16_31, img16_32, img16_33, img16_34, img16_35, img16_36, 
      img16_37, img16_38, img16_39, img16_40, img16_41, img16_42, 
      img16_43, img16_44, img16_45, img16_46, img16_47, img16_48
    ]
    
  },
  '17': {
    id: '17',
    title: "S&P Global",
    company: "",
    thumbnail: thumbnail17,
    imgs: [
      img17_1, img17_2, img17_3, img17_4, img17_5, 
      img17_6, img17_7, img17_8, img17_9, img17_10, 
      img17_11, img17_12, img17_13, img17_14, img17_15, 
      img17_16, img17_17, img17_18, img17_19, img17_20, 
      img17_21, img17_22, img17_23, img17_24, img17_25, 
      img17_26, img17_27, img17_28, img17_29, img17_30, 
      img17_31, img17_32, img17_33, img17_34, img17_35, img17_36, 
      img17_37, img17_38, img17_39, img17_40, img17_41, img17_42, 
      img17_43, img17_44, img17_45, img17_46, img17_47, img17_48, 
      img17_49, img17_50, img17_51, img17_52, img17_53, img17_54
    ]
    
  },
  '18': {
    id: '18',
    title: "S&P Global gala celebrations",
    company: "",
    thumbnail: thumbnail18,
    imgs: [
      img18_1, img18_2, img18_3, img18_4, img18_5, 
      img18_6, img18_7, img18_8, img18_9, img18_10, 
      img18_11, img18_12, img18_13, img18_14, img18_15, 
      img18_16, img18_17, img18_18, img18_19, img18_20, 
      img18_21, img18_22, img18_23, img18_24, img18_25, 
      img18_26, img18_27, img18_28, img18_29, img18_30, 
      img18_31, img18_32, img18_33, img18_34, img18_35, img18_36, 
      img18_37, img18_38, img18_39, img18_40, img18_41, img18_42, 
      img18_43, img18_44, img18_45
    ]
    
  },
  '19': {
    id: '19',
    title: "She Team Hyderabad City Police",
    company: "",
    thumbnail: thumbnail19,
    imgs: [
      img19_1, img19_2, img19_3, img19_4, img19_5, 
      img19_6, img19_7, img19_8, img19_9, img19_10, 
      img19_11, img19_12
    ]
  },
  '20': {
    id: '20',
    title: "Value Labs Annual Event",
    company: "",
    thumbnail: thumbnail20,
    imgs: [
      img20_1, img20_2, img20_3, img20_4, img20_5, 
      img20_6, img20_7, img20_8, img20_9, img20_10, 
      img20_11, img20_12, img20_13, img20_14, img20_15, 
      img20_16, img20_17, img20_18, img20_19, img20_20, 
      img20_21, img20_22, img20_23, img20_24, img20_25, 
      img20_26, img20_27
    ]
  },
}


const projectsVideos = {
  'corporate-celebrations': {
    link: 'corporate-celebrations',
    title: 'Corporate Celebrations',
    videos: [
      "mWrqNoHr2Ps?si=K6BQYb7UkleAsD38",
      "QAUNKcpnwYk?si=d04Mz1rIAPI4qIua",
      "g9C0CYOM3TY?si=xIUNfrnSIM4yRDIU",
      "Wkc_Mu8uQhY?si=4CVdhlZ0XNzHqmjY",
      "8jgm_8UtO18?si=rrMH4XN4ipYLrXjB",
      "3QD8QzuN2wQ?si=xwVhiuEZHre-bIx_",
      "eChibkbdK64?si=kkJivtZNcwDQrVo3",
      "aZW-6HgkhI0?si=HyN6VtmXGu0VenjV",
      // "4GPIrGK0zLY?si=vJitMFMPX7FEUCuF",
      "5L1d5o3R6iQ?si=vZkopaFWs7dQ0Ai1",
      "piYw1lnGjv0?si=pnP5enaqoV9f4K9p",
      "GSD-NQ4O3c8?si=VBSMCebp1m6y7U2l",
      // "5KyTuflJBkg?si=5qL5lth63EzDmPr8",
      "ybB0DeQpwnE?si=iVaR7bgeugoou6RW",
      "qTNBwsWv-Ng?si=_ond0DTvelxPsRdB",
      "J6CTyF2E6Dc?si=6ryIf-nZRblphBEJ",
      // "_NJRe1XJnWk?si=LkdweIlpwdnkxcn1",
      // "-PShexmRZmQ?si=1xaXeF7vHOOLYSzD",
      "_NJRe1XJnWk?si=UV0F5M4JzzkBg40p",
      "-PShexmRZmQ?si=ANWUG-3z0Bp1rAGv",
      "8McNgJe1Ms0?si=62dOH4UlC4CVlcOe",
      "EYGNg7C__OA?si=sfJzxecNWZg_7SvZ",
      "5L1d5o3R6iQ?si=o6MisieXnOXMhkoH",
      "GG6N7nOJNrU?si=24fBuf7aTxHzs8lw",
      "Yxiz8lhLhRo?si=JjHH_cbENzrM2eTB",
      "_9PljPu7v-Q?si=T0zyev3J9odSXRGI"
    ],
  },
  'leadership-meets': {
    link: 'leadership-meets',
    title: 'Leadership Meets',
    videos: [
      "o3QDpI5aIS0?si=6rMntacLQvJMEQfA",
      "hcv1K_8-MRY?si=BLMME12Ul01y2B6i"
    ],
  },
  'virtual-events': {
    link: 'virtual-events',
    title: 'Virtual Events',
    videos: [
     "f2DxUOlrusw?si=YZz-yEyUXlLdxJpZ",
     "BLeyyRQ7P_s?si=htME40_Bs-0kY6Fj",
     "C5VUEpk50bU?si=f0kxorwaz0vnRRyj",
     "Gsvue2k9bnA?si=-aGrQCmOY7asNW5q",
     "rO3Fm3Bd3xU?si=1CNCp8HdiHiX7KhD",
     "YxxIqzOE-gA?si=b7w1SUcx0RjnmAaa"
    ],
  },
  'corporate-audio-visuals': {
    link: 'corporate-audio-visuals',
    title: 'Corporate Audio Visuals',
    videos: [
      "i6qco3CxUC4?si=NXj8AylppH9D_Uey",
      "jIjOjVA38bA?si=Yw5SNBhYpVwwU6DI",
      "EzM3JhtWFAs?si=VGyX8DEFgb9n3vHS",
      "OewS5ptMb6A?si=FhAQZSl6Y-0WCAnP",
      "EzM3JhtWFAs?si=O1aNWcC1U7-LPZL9",
      "nFBELXOfKpQ?si=EPVwpu3wLzu02R6E",
      "leVvgapH7oM?si=EC-Ct3mRuJ7kt8Ao"
    ],
  },
  'social-awareness-events-and-CSR': {
    link: 'social-awareness-events-and-CSR',
    title: 'Social Awareness Events and CSR',
    videos: [
      "JiLGQIHVO4E?si=fsUe7xfniuydAhJ6"
    ],
  }
} 


const root = ReactDOM.createRoot(document.getElementById('root'));

AOS.init({
  duration: 1200,
})


const appRouter = createBrowserRouter([
  {
    path:'/',
    element: <Layout />,
    children: [
      {
        path: '',
        element: <Landing />
      }, 
      {
        path: 'approach',
        element: <ApproachMain />
      },
      {
        path: 'our-approach',
        element: <OurApproach />
      },
      {
        path: 'company',
        element: <Company />
      },
      {
        path: 'about-us',
        element: <AboutUs />
      },
      {
        path: 'testimonials',
        element: <Testimonials />
      },
      {
        path: 'projects',
        element: <Projects projects={projects} />
      },
      {
        path: 'project/:id',
        element: <Project projects={projects} />
      },
      {
        path: 'project-photos',
        element: <ProjectPhotos projects={projects} />
      },
      {
        path: 'project-video-cards',
        element: <ProjectVideoCards projectsVideos={projectsVideos} />
      },
      {
        path: 'project-clips/:id',
        element: <ProjectVideos projectsVideos={projectsVideos} />
      },
      {
        path: 'casestudy/:id',
        element: <CaseStudy />
      }
    ]
  }
])

root.render(
  <React.StrictMode>
    <RouterProvider
      router={appRouter}
      fallbackElement= {<div>Loading...</div>}
    />
  </React.StrictMode>
);

 